import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	linkSizeColor: {
		color: theme.palette.primary.main,
		fontSize: "20px",
		textDecoration: "none",
	},
	container: {
		height: "100%",
		justifyContent: "center",
		flexDirection: "column !important",
		alignItems: "center",
	},
});
